import { axiosIntance } from "./config"

export const login = async(data)=>{
    const response = await axiosIntance.post('/login',data)
    return response.data
}

export const resetPassword = async(data)=>{
    const response = await axiosIntance.post('/reset-password',data)
    return response.data 
}

export const getAuditorBytoken = async()=>{
    const response = await axiosIntance.get('/employee-token')
    return response.data 
}


export const logOut = async()=>{
    const response = await axiosIntance.post('/logout')
    return response.data
}